import * as Sentry from "@sentry/react-native";
type Res =
  | {
      success: true;
      authToken: string;
      idToken: string;
      refreshToken?: string;
      inputRefreshToken: string;
      expiresAt?: number;
    }
  | {
      success: false;
      shouldBeLoggedOut: boolean;
      inputRefreshToken: string;
      logoutReason?: object;
    };

export async function refreshToken(
  tokenUrl: string,
  clientId: string,
  inputRefreshToken: string
): Promise<Res> {
  try {
    Sentry.setTag("json_refresh", "true");
    const response = await fetch(tokenUrl, {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({
        client_id: clientId,
        grant_type: "refresh_token",
        refresh_token: inputRefreshToken,
      }),
    }).catch(() => null);

    if (!response) {
      return {
        success: false,
        shouldBeLoggedOut: false,
        inputRefreshToken,
      }; // network error retry refreshToken
    }
    if (response.status >= 500) {
      return {
        success: false,
        shouldBeLoggedOut: false,
        inputRefreshToken,
      }; // server error retry refreshToken
    }
    if (
      response.status === 400 ||
      response.status === 401 ||
      response.status === 402 ||
      response.status === 403
    ) {
      const text = await response
        .text()
        .then((t) => {
          try {
            return JSON.parse(t);
          } catch {
            return t;
          }
        })
        .catch(() => "");
      return {
        success: false,
        shouldBeLoggedOut: true,
        logoutReason: {
          statusCode: response.status,
          body: text,
        },
        inputRefreshToken,
      };
    }

    const res = await response.json();
    if (
      typeof res.access_token === "string" &&
      typeof res.id_token === "string"
    ) {
      const expiresAt =
        res.expires_in && typeof res.expires_in === "number"
          ? Date.now() + res.expires_in * 1000
          : undefined;
      return {
        success: true,
        authToken: res.access_token,
        idToken: res.id_token,
        expiresAt: expiresAt,
        refreshToken:
          typeof res.refresh_token === "string" ? res.refresh_token : undefined,
        inputRefreshToken,
      };
    } else {
      console.log("Malformed token refresh response", res);
      return {
        success: false,
        shouldBeLoggedOut: false,
        inputRefreshToken,
      };
    }
  } catch (e) {
    Sentry.captureException(e);
    return {
      success: false,
      shouldBeLoggedOut: false,
      inputRefreshToken,
    };
  }
}
